<template>
    <div class="page quiz quiz-2">
        <div class="container-fluid">
            <div class="row">
                <div class="col-8 offset-2 d-flex align-items-center justify-content-center flex-column text-center">
                    <img src="@/assets/global/Miyuki_dori.png" class="img-fluid guide mb-4 w-50">
                    <h2 class="color--red font-size-56 mb-5 font-black text-uppercase">Thank you!</h2>
                    <p class="mb-4">You have reached the end of the tour, we <br> hope that you had a great time!</p>

                    <p class="mb-4">Sharing Beauty is one of the pillars of<br> Shiseido philosophy , so why not sharing<br> this special moment with store collegues?</p>

                    <p class="mb-4">Click here to send a virtual postcard and <br> invite your work collegues to join<br> Discover-Shiseido.com and take the Tokyo tour!</p>
                    <div class="d-flex mt-5 mb-3">
                        <div class="close__module" v-on:click="closeModule">
                            close module
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import lrsService from "@/services/lrsService";
    import Question from "@/components/Question";
    import $ from 'jquery'

    export default {
        name: "page-030",
        components:{
            Question
        },
        props:{
            kapitel: "",
        },
        data: function () {
            return {

            }
        },
        methods: {
            closeModule(){
                let url = this.user.exit_url;
                window.location = 'https://www.discover-shiseido.com'+url;
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>
.guide{
    max-width: 150px;
}
</style>